// extracted by mini-css-extract-plugin
export default {"wrap":"ProductBrandsComponent_wrap__773yq","header":"ProductBrandsComponent_header__VH+ax","tableContainer":"ProductBrandsComponent_tableContainer__HDJJ+"};